import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col} from "react-bootstrap";
import { addCourse, getCourses } from "../../service/apiService";
import "./CourseManagement.css";

function CourseManagement({ user }) {
  const [formData, setFormData] = useState({
    course_name: "",
    fees: "",
    duration: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const fetchCourses = async () => {
    try {
      const res = await getCourses();
      if (res.status === "success") {
        setCourses(res.data || []);
      } else {
        setCourses([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      ...formData,
      created_by: user.id,
    };

    try {
      const res = await addCourse(data);

      if (res.status === "success") {
        alert("Course Added Successfully!");
        setFormData({
          course_name: "",
          fees: "",
          duration: "",
          description: "",
        });
        fetchCourses();
      } else {
        alert(res.message);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong.");
    }

    setLoading(false);
  };

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentCourses = courses.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(courses.length / itemsPerPage);

  return (
    <div className="course-page">
      <h3 className="mb-4">Course Management</h3>

      <Card className="shadow-sm p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Course Name</Form.Label>
                <Form.Control
                  type="text"
                  name="course_name"
                  value={formData.course_name}
                  onChange={handleChange}
                  placeholder="Enter Course Name"
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Course Fees</Form.Label>
                <Form.Control
                  type="number"
                  name="fees"
                  value={formData.fees}
                  onChange={handleChange}
                  placeholder="Enter Course Fees"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Duration</Form.Label>
                <Form.Control
                  type="text"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  placeholder="Example: 3 Months"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Description"
                />
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Course"}
          </Button>
        </Form>
      </Card>

      <Card className="shadow-sm p-4 mt-4">
        <h5 className="mb-3">Course List</h5>

        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Course Name</th>
                <th>Fees</th>
                <th>Duration</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {currentCourses.length > 0 ? (
                currentCourses.map((course, index) => (
                  <tr key={course.id}>
                    <td>{indexOfFirst + index + 1}</td>
                    <td>{course.course_name}</td>
                    <td>Rs. {course.fees}</td>
                    <td>{course.duration}</td>
                    <td>{course.description}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No Courses Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center mt-3 gap-3">

            <Button
              variant="light"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                width: "42px",
                height: "42px",
                borderRadius: "50%"
              }}
            >
              ‹
            </Button>

            <span className="fw-semibold">
              {currentPage} / {totalPages || 1}
            </span>

            <Button
              variant="light"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage(currentPage + 1)}
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                width: "42px",
                height: "42px",
                borderRadius: "50%"
              }}
            >
              ›
            </Button>

          </div>
        )}
      </Card>
    </div>
  );
}

export default CourseManagement;